export default {
    name: 'FundraisingHero',
    setup() {}
}
